<template>
  <div class="delete-dialog">
    <div class="dialog-title">
      {{ $t('是否删除该评论？') }}
    </div>
    <div class="dialog-btn">
      <span
        class="dialog-cancle"
        @click="cancle()"
      >{{ $t('取消') }}</span>
      <span
        class="dialog-confirm"
        @click="confirm()"
      >{{ $t('确认') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    cancle() {
      this.$emit('cancle')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>
<style lang="less" scoped>
.delete-dialog {
  border-radius: 1px;
  position: absolute;
  right: 0;
  width: 216px;
  z-index: 999;
  height: auto;
  overflow: hidden;
  background: #637282;
  padding: 0 6px;
  .dialog-title {
    color: #fff;
    font-size: 12px;
    line-height: 24px;
    margin-left: 6px;
    display: inline-block;
  }
  .dialog-btn {
    display: inline-block;
    float: right;
    .dialog-confirm {
      display: inline-block;
      /*width: 24px;*/
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .dialog-cancle {
      margin-right: 8px;
      display: inline-block;
      /*width: 24px;*/
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
